import { PROFILE } from "@/data/content";
import { scrollToSection } from "@/lib/scroll";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-charcoal-900 border-t border-parchment/10 py-10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col sm:flex-row items-center justify-between gap-5">
        <button
          data-testid="footer-brand-button"
          onClick={() => scrollToSection("#home")}
          className="font-serif text-lg text-parchment"
        >
          {PROFILE.name}
        </button>
        <p className="font-mono text-[11px] tracking-[0.18em] uppercase text-parchment/40 text-center">
          Creative Leadership · Content Operations · Brand Communication · Production &amp; Design
        </p>
        <p className="text-xs text-parchment/40">© {new Date().getFullYear()} {PROFILE.name}</p>
      </div>
    </footer>
  );
}
